<!--
  后台布局
  用途：管理后台顶部栏 + 内容区；退出登录
-->
<template>
  <div class="admin-layout">
    <header class="admin-header">
      <div class="brand">
        <img :src="logoUrl" alt="Logo" />
        <strong>DuoGu 数据管理</strong>
      </div>
      <div class="actions">
        <router-link to="/" target="_blank">查看前台</router-link>
        <button type="button" @click="onLogout">退出登录</button>
      </div>
    </header>
    <main class="admin-main">
      <router-view />
    </main>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'
import { logoutAdmin } from '@/services/api'
import logoUrl from '@/assets/logo.png'

const router = useRouter()

const onLogout = async () => {
  await logoutAdmin()
  router.replace({ name: 'admin-login' })
}
</script>

<style scoped>
.admin-layout {
  min-height: 100vh;
  background: #f5f5f5;
}

.admin-header {
  height: 64px;
  background: #fff;
  border-bottom: 1px solid var(--color-border);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
}

.brand {
  display: flex;
  align-items: center;
  gap: 10px;
}

.brand img {
  width: 36px;
  height: 36px;
  object-fit: contain;
}

.actions {
  display: flex;
  align-items: center;
  gap: 14px;
}

.actions a,
.actions button {
  font-size: 14px;
  color: var(--color-text-secondary);
  background: transparent;
  border: none;
  cursor: pointer;
}

.actions button {
  color: var(--color-primary);
  font-weight: 600;
}

.admin-main {
  max-width: 1100px;
  margin: 0 auto;
  padding: 24px 16px 48px;
}
</style>
